module.exports = __webpack_public_path__ + "static/media/gt.01ce618d.svg";